import React, { useState } from 'react'
import './toast.scss'
export default function Toast({
  children,
  onClose,
}: {
  children: React.ReactNode
  onClose: () => void
}) {
  const [visible, setVisible] = useState(true)
  const handlerClose = () => {
    setVisible(false)
    onClose()
  }
  if (!visible) {
    return null
  }
  return (
    <div className="f-toast">
      <div className="f-toast__card">
        <div className="f-toast__content">{children}</div>
        <a
          onClick={handlerClose}
          role="button"
          className="f-toast__close-btn icon2-close"
        ></a>
      </div>
    </div>
  )
}
